export default function getDatasetFromEvent(
  event: any,
  field: string,
) {
  return event.target.dataset[field]
}
